import { render, staticRenderFns } from "./ProductFiltersProtection.vue?vue&type=template&id=780dc9b0&lang=html&"
import script from "./ProductFiltersProtection.vue?vue&type=script&lang=js&"
export * from "./ProductFiltersProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports